import React, { useState, useRef, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import '../addonService.scss';
import { I18n } from 'react-redux-i18n';

const EditableNumber = ({ 
  value: initialValue = 0, 
  onChange,
  placeholder = "0",
  className = "",
  min,
  max,
  step = 1,
  valueDisplay,
  disabled = false
}) => {
  const [value, setValue] = useState(initialValue || 0);
  const [isEditing, setIsEditing] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleFocus = () => {
    if(disabled) return;
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (onChange) {
      onChange(value);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    
    // Allow empty string for editing
    if (newValue === '') {
      setValue('');
      return;
    }

    const numValue = parseFloat(newValue);
    
    // Validate number
    if (!isNaN(numValue)) {
      // Check min/max constraints
      if (min !== undefined && numValue < min) return;
      if (max !== undefined && numValue > max) return;
      
      setValue(numValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      inputRef.current?.blur();
    }
    if (e.key === 'Escape') {
      setValue(initialValue);
      inputRef.current?.blur();
    }
  };

  const displayValue = value === '' ? placeholder : value;

  return (
    <div className={`editable-number ${className}`}>
      {isEditing && !disabled ? (
        <div className="editable-number__input-container">
          <input
            ref={inputRef}
            type="number"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            min={min}
            max={max}
            step={step}
            className="editable-number__input"
          />
          {max && (
            <span className="editable-number__max">
              {I18n.t('addonService.Max')} {max}
            </span>
          )}
        </div>
      ) : (
        <div
          onClick={handleFocus}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={`editable-number__display ${disabled ? 'isDisabled' : ''}`}
        >
          <span>{valueDisplay}</span>
          {
            !disabled && (
              <FaEdit 
                size={16} 
                className={`editable-number__icon editable-number__icon--visible`}
              />
            )
          }
        </div>
      )}
    </div>
  );
};

export default EditableNumber;